import * as R from 'ramda'
import { validate } from 'email-validator'

export const emailValidator = (email) => validate(email)

export const digitsValidator = R.test(/\d/)

export const phoneValidator = R.test(/^\d{10}$/) // (phone) => /^\d{10}$/.test(phone)

export const minLengthValidator = R.curry(
  (minLength, testString) => testString.length >= minLength
)

export const upperCaseValidator = R.test(/[A-Z]|Ñ/)

export const lowerCaseValidator = R.test(/[a-z]|ñ/)

export const specialCharValidator = R.test(/[^A-Za-z0-9]/)

export const upperAndLowerCaseValidator = R.allPass([
  lowerCaseValidator,
  upperCaseValidator
])
